import { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";

// Accessible password input with a show/hide (eye) toggle. The revealed value is
// only ever shown in this input on the customer's own screen. It is never logged
// or exposed elsewhere, and password handling/security is unchanged.
export function PasswordField({ value, onChange, placeholder, testid, onKeyDown, autoComplete = "current-password" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#A89A88]" />
      <input
        data-testid={testid}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className="w-full rounded-xl pe-surface py-3 pl-10 pr-11 text-[15px] text-[#171717] outline-none transition-colors focus:border-[#2F6B57] focus:ring-2 focus:ring-[#2F6B57]/25"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={testid ? `${testid}-toggle` : undefined}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-lg p-1.5 text-[#A89A88] transition-colors hover:text-[#2F6B57] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2F6B57]/40"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
